// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"8f63b0a8","183":"0c265ab1","786":"39bd774d"}[chunkId] + ".chunk.js";
};